import React from "react";
import PropTypes from "prop-types";
import colors from "app/theme/base/colors";

export default function SlotContentEdit({ slot, compact = false }) {
  const { name, sets, reps, rest, tempo, intensity, notes } = slot;

  const showMainLine = sets || reps || rest;

  return (
    <div
      style={{
        height: "100%",
        width: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        gap: compact ? "1px" : "2px",
        overflow: "hidden",
        textAlign: "center",
      }}
    >
      {/* Nombre */}
      <div
        style={{
          fontWeight: 600,
          fontSize: compact ? "0.70rem" : "0.74rem",
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
          color: colors.text.primary,
          flexShrink: 0,
        }}
      >
        {name}
      </div>

      {/* Línea principal (sets / reps / rest independientes) */}
      {showMainLine && (
        <div
          style={{
            fontSize: compact ? "0.60rem" : "0.63rem",
            color: colors.grey[700],
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {/* Sets */}
          {sets && <span>{sets}</span>}

          {/* Multiplicador solo si hay sets y reps */}
          {sets && reps && <span>×</span>}

          {/* Reps */}
          {reps && <span>{reps}</span>}

          {/* Descanso */}
          {rest && (
            <span>
              {(sets || reps) && " | "}
              {rest}
              <span>s</span>
            </span>
          )}
        </div>
      )}

      {/* Notas */}
      {notes && (
        <div
          style={{
            fontSize: compact ? "0.58rem" : "0.57rem",
            color: colors.grey[700],
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {notes}
        </div>
      )}

      {/* Tempo + intensidad (solo NO compact) */}
      {!compact && (tempo || intensity) && (
        <div
          style={{
            fontSize: "0.60rem",
            color: colors.text.secondary,
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            letterSpacing: "0.2px",
          }}
        >
          {intensity && intensity}
          {intensity && tempo && " · "}
          {tempo && tempo}
        </div>
      )}
    </div>
  );
}

SlotContentEdit.propTypes = {
  slot: PropTypes.object.isRequired,
  compact: PropTypes.bool,
};
